import { IdLoca } from "../../utils/i18n/IdLoca";
import { StatusCode } from "../../utils/network/generated/protoTypes";
export var mapTextError = new Map()
    .set(StatusCode.NAME_INVALID, IdLoca.error_invalidCharacters)
    .set(StatusCode.NAME_IN_USE, IdLoca.error_nameAlreadyExists)
    .set(StatusCode.BAD_WORD, IdLoca.error_badwordInName)
    .set(StatusCode.BAD_WORD_IN_SECOND_FIELD, IdLoca.error_badwordInDesc)
    .set(StatusCode.INVALID_AMOUNT, IdLoca.error_nameTooShort);



//////////////////
// WEBPACK FOOTER
// ./src/features/set-player-name/mapTextError.ts
// module id = 553
// module chunks = 3